import apiClient from './api';

export const getEvents = () => apiClient.get('/event');

export const upsertEvent = (data) => apiClient.post('/event', data);

export const deleteEvent = (id) => apiClient.delete(`/event/${id}`);